// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'


import Vue from 'vue';
import VueRouter from 'vue-router';
import moment from 'moment-timezone';

moment.tz.setDefault('America/Indiana/Indianapolis')

import App from './App';
import store from './store/store';

import routes from './router/routes';

import './styles/frontend.css';

const BASE_API = process.env.VUE_API_ROOT;
const INFO_VERSION = process.env.INFO_VERSION;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueRouter);
Vue.use(require('vue-moment'), {
  moment,
});

Vue.config.productionTip = false;
Vue.prototype.$api = process.env.VUE_API_ROOT;

const router = new VueRouter({
  mode: 'history',
  routes,
});

function setTitle(to) {
  let title = to.meta.title ? to.meta.title : "AndyMark Info"
  if (title === "Order View") {
    title = to.params.id
  }
  document.title = title
}

router.beforeEach(async (to, from, next) => {
  const title = to.meta.title ? to.meta.title : "AndyMark Info"
  if (to.path === '/') {
    next()
  } else if (INFO_VERSION) {
    axios.get(`${BASE_API}/auth`).then(r => {
      if (auth) {
        setTitle(to)
        next()
      }
      else ('/')
    }).catch(() => next('/'))
  } else {
    setTitle(to)
    next();
  }
})

Vue.filter('formatDollars', dollars => Intl.NumberFormat('en', {
  style: 'currency',
  currency: 'USD',
}).format(Number(dollars)));
Vue.filter('formatPhone', phone => {
  let cleaned = ('' + phone).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    let intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }

  console.warn('phone number didn\'t match US format, returning it unformatted')
  return phone;
})
Vue.filter('titleize', string => {
  if (string) {
    return string.split('_').map(e => e.charAt(0).toUpperCase() + e.slice(1)).join(' ')
  } else {
    return 'null';
  }
});
Vue.filter('formatNumber', number => Intl.NumberFormat('en').format(Number(number)))
Vue.filter('round', number => Math.round(Number(number)))
Vue.filter('roundDouble', number => Math.round(Number(number) * 100) / 100)
Vue.filter('htmlify', string => string.replaceAll('\n', '<br>'))

Vue.mixin({
  methods: {
    infoAuditLog(action, buttonText, soNum, params, original=null) {
      axios({
        url: `${BASE_API}/audit/`,
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        data: {
          action: `${action} ("${buttonText}")`,
          soNum,
          params,
          original,
        },
      });
    },
  },
});

/* TODO: Delete this after upgrading Vue versions, its a fixed error on newer versions */
const ignoredMessage = "The .native modifier for v-on is only valid on components but it was used on <a>.";
Vue.config.warnHandler = (message, vm, componentTrace) => {
    if (message !== ignoredMessage) {
        console.error(message + componentTrace);
    }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  store,
});



// WEBPACK FOOTER //
// /src/main.js